import React from 'react';
import DataTable from '../../../ShearCompo/DataTable/DataTable';
import Summary from '../../../ShearCompo/Summary/Summary';
import { Icon } from '@material-ui/core';

import { useState } from 'react';
import ModalLayout from '../../../ShearCompo/ModalLayout/ModalLayout';
import { ManageRoleForm, ManageRolesEditDetails } from '../../../AllForms/AdminFrom/ManageRoleForm';
import { Form } from 'react-bootstrap';


const ManageRole = () => {

    const RoleFakeData = [
        {
            id: '#546651',
            name: 'Admin',
            description: 'All access Roles',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546652',
            name: 'Manager',
            description: 'Sub access Role',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546653',
            name: 'Assistant Manager',
            description: 'Partial access to manager role',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546654',
            name: 'Delivery',
            description: 'Can View Only Delivery Features',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546655',
            name: 'Vendor',
            description: 'Can View Only CSM Features',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546656',
            name: 'Misc',
            description: 'Misc access to different pages',
            creationDate: '4:44AM 17 August, 2021',
        },
        {
            id: '#546657',
            name: 'Test',
            description: 'Test Role',
            creationDate: '4:44AM 17 August, 2021',
        },
    ]
    const tableHeading = ['Role ID', 'Role Name', 'Role Description', 'Creation Date', 'Action']
    const roleSummaryData = [
        {
            name: "Total Role",
            price: "541 Roles",
            img: 'https://i.ibb.co/kgRPWkD/Total-users.png'
        },
        {
            name: "This Year",
            price: "541 Roles",
            img: 'https://i.ibb.co/bgJpSVj/This-Year.png'
        },
        {
            name: "This Month",
            price: "5 Roles",
            img: 'https://i.ibb.co/5sf3jNQ/This-Months.png'
        },
        {
            name: "This Week",
            price: "1 Role",
            img: 'https://i.ibb.co/HgjVJbz/This-Week.png'
        },
    ];

    const [lgShow, setLgShow] = useState(false)
    const handleClose = () => {
        setLgShow(false);
        setEditDetailsF(false);
    }
    const [editDetailsF, setEditDetailsF] = useState(false);
    // const [Delete, setDelete] = useState(false);
    const [singleRoleData, setSingleRoleData] = useState({});

    let handleShow = () => setLgShow(true);
    //handleEdit
    const handleEdit = (e) => {
        setEditDetailsF(true);
        const getUserById = RoleFakeData.find(data => data.id === e);
        setSingleRoleData(getUserById);
    }
    //handleDelete
    // const handleDelete = (e) => {
    //     // setDelete(true);
    //     const getUserById = RoleFakeData.find(data => data.id === e);
    //     setSingleRoleData(getUserById);
    // }

    return (
        <div className="w-100 overflow-hidden">
            <>
                <div className="row pt-4">
                    <Summary summaryArrData={roleSummaryData} summaryTitle="Role Summary" />
                </div>
                <div className="adminBtn d-flex justify-content-between">
                    <div className="d-flex csvPdfParent">
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download CSV</span>
                        </div>&nbsp;&nbsp;&nbsp;
                        <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                            <Icon className="MainLightGreen">download</Icon>
                            <span>Download PDF</span>
                        </div>
                    </div>
                    <div className=" singleBtn MAIN_BG_DARK_GREEN text-white mx-0">
                        <div onClick={handleShow} className="d-flex align-items-center">
                            <Icon className="me-3">add</Icon>
                            <span >Add Role</span>
                        </div>
                    </div>
                </div>

                {/* manage role from */}
                <ModalLayout ModalTitle="Add Role" handleClose={handleClose} Show={lgShow} modalBody={<ManageRoleForm></ManageRoleForm>} />
            </>

            {/* manage role data table */}
            <DataTable
                tableInputFrom={
                    <Form className="col-lg-5 p-0 tableSearch topInputFrom" id="topInputFrom1">
                        <div className="form-bd shadow-sm rounded">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button id="button-addon3" type="submit" className="btn btn-link text-muted d-flex align-items-center">
                                        <Icon className="mt-1">search</Icon>
                                    </button>
                                </div>
                                <input type="search" placeholder="Search manage role" className=" topSearchInput form-control rounded " />
                            </div>
                        </div>
                    </Form>
                }
                tableHeading={tableHeading} tableBodyData={
                    RoleFakeData && RoleFakeData.map((tableData, index) =>
                        <tr key={index} className="text-center">
                            <th scope="row">{tableData.id}</th>
                            <td>{tableData.name}</td>
                            <td>{tableData.description}</td>
                            <td> {tableData.creationDate} </td>
                            <td className="d-flex justify-content-center align-items-center">
                                <span className="cursorPointer MainDarkGreen" onClick={() => handleEdit(tableData.id)}>
                                    <i className="fas fa-pencil-alt"></i>&nbsp;Edit
                                </span>
                                &nbsp;&nbsp;&nbsp;
                                <span className="cursorPointer LIGHT_RED">
                                    <i className="far fa-trash-alt"></i>&nbsp;Delete
                                </span>
                            </td>
                        </tr>
                    )
                } />

            <ModalLayout
                ModalTitle={`${'Group Id-' + singleRoleData.id}`}
                Show={editDetailsF}
                handleClose={handleClose}
                // manage role edit from
                modalBody={<ManageRolesEditDetails userDetails={singleRoleData} />}
            />

        </div>
    );
};

export default ManageRole;